<template>
  <div>
    
    <v-card>
      <v-toolbar flat color="white" dense>
        <h3 class="text-subtitle-2">Adicionar Produto</h3>
        <!-- <v-btn color="primary" @click="$refs.dialogoSelecionarVariacao.abrir()">Variação</v-btn> -->

        <v-spacer></v-spacer>
        <span class="mr-5">Itens: {{ produtos.length }}</span>
        <span class="mr-5">Valor Total: {{ total | valorBR }}</span>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="pb-0">
        <v-row dense>
          <v-col cols="2" sm="2">
            <z-text-field
              v-model="referencia"
              append-icon="search"
              ref="referencia"
              label="Referência"
              placeholder=" "
              autofocus
              select
              :loading="buscando"
              :hide-details="hidedetails"
              :disabled="buscando"
              @keyup.enter="buscarProdutoPorReferencia"
              @keyup.esc="onKeyUpEscAdicionarProduto"
              @click:append="buscarProduto"
              @focus="current_focus = 'referencia'"
            ></z-text-field>
          </v-col>
          <v-col cols="4" :sm="somenteQuantidade ? 8 : 4">
            <z-text-field
              v-model="produto.descricao"
              ref="descricao"
              label="Descrição"
              readonly
              dense
              :hide-details="hidedetails"
              :disabled="buscando"
            ></z-text-field>
            <div class="d-flex" style="gap: 2px; margin-top: -15px" v-if="produto.grade">
              <v-chip
                v-for="(grade, index) in produto.grade"
                x-small
                :key="index"
                @click="$refs.dialogoSelecionarVariacao.abrir()"
              >{{ grade.descricao }}</v-chip>
            </div>
          </v-col>
          <v-col cols="2" sm="2">
            <z-campo-valor
              v-model="produto.quantidade"
              ref="quantidade"
              label="Quantidade"
              append-icon_="mdi-view-list"
              filled
              dense
              persistent-hint
              :hint="`Estoque: ${produto.estoque} (F2 - Exibir)`"
              :label="labelQuantidade"
              :hide-details="hidedetails"
              :decimais="config.CASAS_DECIMAIS_QUANTIDADE"
              :disabled="buscando || !produto.descricao || adicionando"
              @keyup.enter="enterQuantidade"
              @keyup.esc="onKeyUpEscAdicionarProduto"
              @input="calcularSubTotal"
              @click:append="exibirEntradas(produto)"
              @keyup.f2="exibirEntradas(produto)"
              @focus="current_focus = 'quantidade'"
            >
              <template #append v-if="current_focus == 'quantidade'">
                <v-btn 
                  class="ml-3" 
                  color="primary"
                  x-small 
                  depressed
                  :disabled="buscando || !produto.descricao || adicionando"
                  @click="adicionarProduto2"
                >
                  Enter
                </v-btn>
              </template>
            </z-campo-valor>
          </v-col>
          <v-col cols="2" sm="2" v-if="!somenteQuantidade">
            <z-campo-valor
              v-model="produto.valor"
              ref="valor"
              filled
              dense
              :label="movimentoEstoque ? 'Valor Custo' : 'Valor'"
              :hide-details="hidedetails"
              :disabled="buscando || !produto.descricao || adicionando"
              :readonly="!this.alterarPreco"
              @keyup.enter="adicionarProduto2"
              @keyup.esc="onKeyUpEscAdicionarProduto"
              @input="calcularSubTotal"
              @focus="current_focus = 'valor'"
            >
            <template #append v-if="config.ALTERAR_PRECO_NO_PEDIDO && current_focus == 'valor'">
              <v-btn 
                class="ml-3" 
                color="primary"
                x-small 
                depressed
                :disabled="buscando || !produto.descricao || adicionando"
                @click="adicionarProduto2"
              >
                Enter
              </v-btn>
            </template>
            </z-campo-valor>
          </v-col>
          <v-col cols="2" sm="2" v-if="!somenteQuantidade">
            <z-campo-valor
              v-model="produto.subtotal"
              ref="subtotal"
              label="SubTotal"
              filled
              dense
              readonly
              :hide-details="hidedetails"
              :disabled="buscando || !produto.descricao"
            ></z-campo-valor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    
    <!-- <dialogo-buscar-produto
      ref="buscaproduto"
      @selecionar:produto="selecionarProduto"
    ></dialogo-buscar-produto> -->

    <dialogo-buscar-produto-grupos 
      ref="buscaproduto" 
      @selecionar:produto="selecionarProduto"
    ></dialogo-buscar-produto-grupos>

    <selecionar-variacao 
      ref="dialogoSelecionarVariacao" 
      :produto="produto"
      @cancelar="onKeyUpEscAdicionarProduto"
      @selecionar:variacao="selecionarVariacao"
    ></selecionar-variacao>

    <dialogo-exibir-entradas ref="dialogoExibirEntradas" @selecionar:grade="selecionaGradeDasEntradas"></dialogo-exibir-entradas>

  </div>
</template>

<script>
import BuscaProduto from "@/pages/pedidos/BuscaProduto";
import DialogoBuscarProduto from "@/pages/pedidos/DialogoBuscarProduto";
import SelecionarVariacao from "@/pages/pedidos/SelecionarVariacao";
import DialogoExibirEntradas from "@/pages/produtos/DialogoExibirEntradas";
import DialogoBuscarProdutoGrupos from "@/components/buscas/DialogoBuscarProdutoGrupos";

import produtosApi from "@/app/services/produtos";
import pedidosApi from "@/app/services/pedidos";
import { trunc } from "@/app/helpers/conversoes";

const tela = {
  PEDIDO_VENDA:  'pedido_venda',
  MOVIMENTO_ESTOQUE: 'movimento_estoque',
  PEDIDO_COMPRA: 'pedido_compra',
};

export default {
  name: 'AdicionarProduto',

  components: {
    BuscaProduto,
    DialogoBuscarProduto,
    SelecionarVariacao,
    DialogoExibirEntradas,
    DialogoBuscarProdutoGrupos,
  },

  props: {
    pedido: {
      type: Object,
      default: () => {}
    },

    produtos: {
      type: Array,
      default: () => []
    },

    tela: {
      type: String,
      default: tela.PEDIDO_VENDA
    },

    // adicionando: {
    //   type: Boolean,
    //   default: false
    // },

    permitirProdutosDuplicados: {
      type: Boolean,
      default: false
    },

    somarProdutos: {
      type: Boolean,
      default: false
    },

    alterarPreco: {
      type: Boolean,
      default: false
    },

    movimentoEstoque: {
      type: Boolean,
      default: false
    },

    somenteQuantidade: {
      type: Boolean,
      default: false
    },

    total: {
      type: Number,
      default: 0
    },
  },

  data() {
    return {
      current_focus: 'referencia',
      referencia: null,
      produto: {
        referencia: '',
        descricao: '',
        quantidade: 1,
        unidade: null,
        valor: 0,
        subtotal: 0,
        estoque: 0,
        grade: [],
        variacoes: [],
        status: null,
      },

      buscando: false,
      hidedetails: false,
      adicionando: false,
    }
  },

  computed: {
    config() {
      return this.$store.state.configuracoes;
    },

    labelQuantidade() {
      return this.produto.unidade ? "Quantidade (" + this.produto.unidade + ")" : "Quantidade";
    },
  },

  methods: {
    async buscarProdutoPorReferencia() {
      this.limparForm();

      if (!this.referencia) {
        this.buscarProduto();
        return;
      }

      if (this.produtoAdicionado(this.referencia)) {
        return;
      }

      try {
        this.buscando = true;
        let produto = await produtosApi.buscarProdutoPorReferencia(this.referencia);
        if (produto) {
          // TODO: REFAZER PARA USAR OS LOTES DE PRODUTOS A APARTIR DO REGISTRO_ESTOQUE
          // if (produto.lotes > 1) {
          //   this.$refs.buscaproduto.busca = this.referencia;
          //   this.$refs.buscaproduto.buscar();
          //   this.$refs.buscaproduto.abrir();
          // }
          this.selecionarProduto(produto);
        }
      } catch (error) {
        this.$refs.referencia.focus();
        this.$eventbus.erro("Produto não encontrado.", error);
        throw error;
      } finally {
        this.buscando = false;
      }
    },

    onKeyUpEscAdicionarProduto() {
      if (this.exibindoEntradas) {
        this.exibindoEntradas = false;
        this.setFocus("quantidade");
      } else {
        // if (!this.produto.grade) {
          this.limparForm();
          this.referencia = null;
        // }
        this.setFocus("referencia");
      }
    },

    buscarProduto() {
      this.$refs.buscaproduto.abrir();
      // this.drawerProdutos = true
      // this.setFocus('buscarproduto');
      // this.$store.commit('TOGGLE_RIGHT_DRAWER')
    },

    calcularSubTotal() {
      this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));
    },

    adicionarProduto() {
      if (!this.validarQuantidade()) return;

      // delete this.produto.estoque;

      delete this.produto.variacoes;

      this.$emit('adicionar', this.produto);
      this.limparForm();
      this.referencia = null;

      this.$refs.referencia.focus();

    },

    async adicionarProduto2() {

      if (this.current_focus == 'quantidade' && this.alterarPreco) {
        this.$refs.valor.focus();
        return;
      }

      // console.log({...this.produto});
      try {
        this.adicionando = true;

        if (this.config.NAO_VENDER_SEM_VALOR_CUSTO == true) {
          if (this.produto.valor_custo == 0) {
            this.$eventbus.notificar("Esse produto não possui valor de custo definido do cadastro.");
            return;
          }
        }

        if (!this.validarQuantidade()) 
          return;

        let produto = this.clone(this.produto);
        produto.status = this.$globals.STATUS_PRODUTO.NEW;
        // delete produto.estoque;

        if (this.tela === tela.PEDIDO_VENDA && this.config.BAIXAR_ESTOQUE_NA_VENDA) {
          const { index, produto: produto_encontrado } = this.encontrarProdutoNoPedido(produto, this.produtos);
          produto.pedido_item_id = index > -1 ? produto_encontrado.id : null;
          
          const { pedido_item } = await pedidosApi.adicionaritem({
            pedido_id: this.pedido.id,
            produto: produto,
          });

          produto.id = pedido_item.id;
        }

        if (this.config.SOMAR_PRODUTOS_PEDIDO) {  //&& !produto.grade
          this.somarProduto(produto);
        } else {

          // if ([tela.PEDIDO_VENDA, tela.MOVIMENTO_ESTOQUE].includes(this.tela)) {
            this.produtos.push(produto);
          // } else if (this.tela == tela.PEDIDO_COMPRA) {
          //   this.produtos.push({
          //     produto_id: produto.produto_id,
          //     referencia: produto.referencia,
          //     descricao: produto.descricao,
          //     quantidade: produto.quantidade,
          //     unidade: produto.unidade,
          //     valor: produto.valor,
          //     quantidade_entregue: 0,
          //   });
          // }
        }

        // this.$emit('adicionar', this.produto);

        this.limparForm();
        this.referencia = null;
        this.$refs.referencia.focus();
      } catch (error) {
        throw error;
        // this.$eventbus.erro("Não foi possível adicionar o produto.");
      } finally {
        this.adicionando = false;
      }

      // this.hidedetails = true;
    },

    enterQuantidade() {
      
      if (this.config.ALTERAR_PRECO_NO_PEDIDO) {
        this.$refs.valor.focus();
        return;
      }

      this.adicionarProduto2();
    },
    // validarQuantidade() {
    //   if (this.produto.quantidade < 1) {
    //     this.$eventbus.notificar("A quantidade não é válida.");
    //     return false;
    //   }

    //   if (this.produto.quantidade > this.produto.estoque) {
    //     this.$eventbus.notificar("Quantidade insuficiente no estoque.");
    //     this.$refs.quantidade.focus();
    //     return false;
    //   }
    //   return true;
    // },

    somarProduto(produto) {
      const { index, produto: produto_encontrado } = this.encontrarProdutoNoPedido(produto, this.produtos);

      if (index > -1) {
        // const produto_encontrado = this.produtos[index];
        produto_encontrado.status = produto_encontrado.status != this.$globals.STATUS_PRODUTO.NEW ? this.$globals.STATUS_PRODUTO.CHANGED : produto_encontrado.status;
        produto_encontrado.quantidade = Number(produto.quantidade) + Number(produto_encontrado.quantidade);
        produto_encontrado.subtotal = trunc(Number(produto_encontrado.quantidade) * Number(produto_encontrado.valor));
        this.produtos.splice(index, 1, produto_encontrado);
      } else {
        this.produtos.push(produto);
      }
    },

    encontrarProdutoNoPedido(produto, produtos) {
      let index = -1;

      const isProdutoDeleted = (produto) => produto.status == this.$globals.STATUS_PRODUTO.DELETED;

      if (!produto.grade) {
        index = produtos.findIndex(_produto => _produto.produto_id == produto.produto_id && !isProdutoDeleted(_produto));
      } else {
        index = this.parseProdutos(produtos).findIndex(_produto => {
          return _produto.grade_descricao == this.parseGradeProduto(produto).grade_descricao && !isProdutoDeleted(_produto);
        });
      }

      return {
        index,
        produto: produtos[index]
      };
    },

    parseProdutos(produtos) {
      let result = [];

      produtos.forEach(item => {
          if ((!!item.grade && item.grade.length === 0) || !item.grade) {
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: null
              });
          } else {
              let grade = '';
              item.grade.forEach(gradeItem => {
                grade += gradeItem.descricao;
              });
              
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: grade
              });
          }
      });

      return result;
    },

    parseGradeProduto(produto) {
      let grade = '';
      produto.grade.forEach(gradeItem => {
        grade += gradeItem.descricao;
      });
      
      return {
          id: produto.produto_id,
          referencia: produto.referencia,
          descricao_produto: produto.descricao,
          grade_descricao: grade
      }
    },

    selecionarProduto(produto) {
      if (this.produtoAdicionado(produto.referencia)) {
        return;
      }
      this.referencia = produto.referencia;
      this.produto.produto_id = produto.id;
      this.produto.referencia = produto.referencia;
      this.produto.descricao = produto.descricao;
      this.produto.valor = this.movimentoEstoque ? produto.valor_custo : produto.valor_venda;
      this.produto.valor_custo = produto.valor_custo;
      this.produto.quantidade = 1;
      this.produto.unidade = produto.unidade;
      this.produto.estoque = produto.estoque;
      this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));
      this.produto.variacoes = produto.variacoes;

      if (produto.variacoes.length > 0) {
        if (this.movimentoEstoque) {
          this.$refs.dialogoSelecionarVariacao.abrir();
        } else {
          this.exibirEntradas(this.produto);
        }
        return;
      }

      this.drawerProdutos = false;
      this.setFocus("quantidade");
      // if (this.config.BAIXAR_ESTOQUE_NA_VENDA) this.hidedetails = false;
    },

    selecionarVariacao({ grade, quantidade }) {
      this.$set(this.produto, "grade", grade);
      this.produto.quantidade = quantidade;
      this.produto.subtotal = trunc(Number(this.produto.quantidade) * Number(this.produto.valor));
      this.setFocus("quantidade");
    },

    produtoAdicionado(referencia) {
      if (this.permitirProdutosDuplicados || this.somarProdutos) {
        return false;
      }

      let produto_adicionado = this.produtos.some(produto => produto.referencia == referencia);

      if (produto_adicionado) {
        this.$eventbus.notificar("Produto já foi adicionado ao pedido.");
        return true;
      }

      return false;
    },

    validarQuantidade() {
      if (this.produto.quantidade == 0) {
        this.$eventbus.notificar("A quantidade não é válida.");
        return false;
      }

      if (!this.movimentoEstoque && (this.produto.quantidade > this.produto.estoque)) {
        this.$eventbus.notificar("Quantidade insuficiente no estoque.");
        this.$refs.quantidade.focus();
        return false;
      }
      return true;
    },

    limparForm() {
      // this.referencia = null;
      this.produto = {
        referencia: null,
        descricao: null,
        quantidade: 1,
        unidade: "",
        valor: 0,
        subtotal: 0,
        estoque: 0,
      };
    },

    exibirEntradas(produto) {
      this.$store.commit("produtos/SET_PRODUTO", produto);
      this.$refs.dialogoExibirEntradas.abrir();
      this.exibindoEntradas = true;
    },

    focus() {
      this.$refs.referencia.focus();
    },

    selecionaGradeDasEntradas(item) {
      // console.log({...item});
      const grade = item.grade.map(grade => {
        return {
          id: grade.id,
          descricao: grade.descricao,
          variacao_id: grade.variacao.id,
        }
      });
      this.$set(this.produto, "grade", grade);
      setTimeout(() => {
        this.$refs.quantidade.focus();
      }, 10);

      // this.valores_selecionados = grade;

      // this.variacao_selecionada = 0;
      // this.variacao = this.produto.variacoes[0];
      // this.onVariacaoClick(this.variacao);

      // setTimeout(() => {
      //   this.onVariacaoClick(this.variacao);
      // }, 10);
      // this.setFocus("quantidade");
    },
  },
}
</script>

<style lang="scss" scoped>

</style>